import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    paddingBottom: 24,
    backgroundColor: Colors.white,
    minHeight: '100vh',
    boxSizing: 'border-box',
    '& .btn-filter': {
      textTransform: 'none',
      borderRadius: 8,
      padding: '4px 12px',
    },
    '& .btn-req': {
      border: `1px solid ${Colors.greyDark} !important`,
      color: Colors.black,
      textTransform: 'none',
      fontWeight: '700',
      fontSize: 16,
    },
    '& .valid': {
      top: 8,
      left: 16,
      zIndex: 1,
    },
    '& .content-card': {
      boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
      border: '1px solid #F3F3F3',
      padding: '16px 12px',
      borderRadius: 8,
    },
  },
};

export default styles;
